export default import.meta.ROLLUP_FILE_URL_BfKVYl3sil6vb1saeRpZ2g